const openers = new Set();

const dimmer = document.querySelector(".full-screen-dimmer");

window.openDimmer = (opener) => {
  openers.add(opener);
  dimmer.classList.add("full-screen-dimmer--active");
};

window.closeDimmer = (opener) => {
  openers.delete(opener);

  if (!openers.size) {
    dimmer.classList.remove("full-screen-dimmer--active");
  }
};
